/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type AssetReallocationBodySection = (typeof AssetReallocationBodySection)[keyof typeof AssetReallocationBodySection];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AssetReallocationBodySection = {
  available_amount: "available_amount",
  financial_asset: "financial_asset",
} as const;
